import { createFileRoute } from '@tanstack/react-router';

import { CustomColumnsConfigView } from '../../../features/custom-columns/admin-config-view';

export const Route = createFileRoute('/columns/custom-configuration/')({
  staticData: { breadcrumb: 'Custom Columns' },
  component: CustomColumnsConfigView,
});
